import * as React from 'react'
import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { BreadCrumbsDot } from "../Icons/Icons"

function handleClick(event) {
  event.preventDefault()
}

const BasicBreadcrumbs = ({ title, titleActive }) => {
  return (
    <div role="presentation" onClick={handleClick}>
      <Breadcrumbs aria-label="breadcrumb"
        separator={<BreadCrumbsDot />}>
        {titleActive.map((title, index) =>
          <Typography
            key={index}
            className="text-text-primary text-md">
            {title}
          </Typography>
        )}
        {title.map((title, index) =>
          <Link
            key={index}
            underline="hover"
            className="text-text-secondary text-md"
            href="/">
            {title}
          </Link>
        )}
      </Breadcrumbs>
    </div>
  )
}
export default BasicBreadcrumbs